// src/redux/reducers/siteSettingsReducer.js

import {
  GET_SITE_SETTINGS_REQUEST,
  GET_SITE_SETTINGS_SUCCESS,
  GET_SITE_SETTINGS_ERROR
} from "../ActionTypes/ActionTypes.js";

const initialState = {
  loading: false,
  settings: null,
  error: null,
};

const siteSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SITE_SETTINGS_REQUEST:
      return { ...state, loading: true, error: null };

    case GET_SITE_SETTINGS_SUCCESS:
      return { ...state, loading: false, settings: action.payload };

    case GET_SITE_SETTINGS_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default siteSettingsReducer;
